import { Col, Container, Row } from "reactstrap";
import {
  MaskedZipCode,
  MaskedCardSecurityCode,
  MaskedExpiryDate,
  TextField,
} from "../../common/VFX-UI";

const CreditCardDetails = () => {
  return (
    <Container className="mt-3">
      <Row>
        <Col className="col-12">
          <TextField
            label="Credit Card Number"
            name="creditCardNumber"
            isRequired={true}
            type="number"
          />
        </Col>
        <Col className="col-12 col-md-6">
          <TextField
            label="First Name"
            name="cardHolderFirstName"
            isRequired={true}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <TextField
            label="Last Name"
            name="cardHolderLastName"
            isRequired={true}
          />
        </Col>
        <Col className="col-12 col-md-4">
          <MaskedExpiryDate
            label="Exp. Date"
            name="expirationDate"
            isRequired={true}
          />
        </Col>
        <Col className="col-12 col-md-3">
          <MaskedCardSecurityCode label="CVV" name="cvv" isRequired={true} type="password"/>
        </Col>
        <Col className="col-12 col-md-5">
          <MaskedZipCode name="zip" label="Zip" isRequired={true} />
        </Col>
      </Row>
    </Container>
  );
};

export default CreditCardDetails;
